export const WORKDAY_START_END_CODES = [
  'MoS',
  'MoE',
  'TuS',
  'TuE',
  'WeS',
  'WeE',
  'ThS',
  'ThE',
  'FrS',
  'FrE',
  'SaS',
  'SaE',
  'SuS',
  'SuE',
];
